import { supabase } from '@/integrations/supabase/client';

export const BUDGET_LINES_PAGE_SIZE = 1000;

function budgetLinesPage(jobId: string, from: number) {
  return supabase
    .from('budget_lines')
    .select('*')
    .eq('job_id', jobId)
    .range(from, from + BUDGET_LINES_PAGE_SIZE - 1);
}

export type BudgetLineRow = NonNullable<Awaited<ReturnType<typeof budgetLinesPage>>['data']>[number];

function chapterOf(row: BudgetLineRow): number {
  return Number(row.capitulo ?? row.chapter ?? 0);
}

export function sortByChapterAndPartida(rows: BudgetLineRow[]): BudgetLineRow[] {
  return rows
    .map((row, index) => ({ row, index }))
    .sort((a, b) =>
      chapterOf(a.row) - chapterOf(b.row)
      || String(a.row.partida ?? '').localeCompare(String(b.row.partida ?? ''))
      || a.index - b.index)
    .map(({ row }) => row);
}

export async function fetchAllJobBudgetLines(jobId: string): Promise<BudgetLineRow[]> {
  const rows: BudgetLineRow[] = [];
  const seen = new Set<string>();
  for (let from = 0; ; from += BUDGET_LINES_PAGE_SIZE) {
    const { data, error } = await budgetLinesPage(jobId, from);
    if (error) throw new Error(error.message);
    const page = data ?? [];
    for (const row of page) {
      const id = String(row.id ?? '');
      if (id && seen.has(id)) continue;
      seen.add(id);
      rows.push(row);
    }
    if (page.length < BUDGET_LINES_PAGE_SIZE) return sortByChapterAndPartida(rows);
  }
}
